import type { ApiMagentoPurchaseType } from "@jti/magento-types/src/api/api-magento-consumables-matrix.types";

import type {
  ConsumableMatrixItem,
  ConsumablesMatrixData,
} from "@product-details/containers/ConsumablesProductDetailsContainer/ConsumablesProductDetailsContainer.types";

export const getMatrixItemsByPurchaseType = (
  consumablesMatrixData: ConsumablesMatrixData,
  purchaseType: ApiMagentoPurchaseType
): ConsumableMatrixItem[] => {
  return consumablesMatrixData.items.filter((item) => item.purchaseType === purchaseType);
};
